import { Container, Typography } from '@evocolabs/orkaui'
import { ContentTitle, SectionTitle } from '../title'
import { Stack, SxProps } from '@mui/material'

import ImageCard from '../ImageCard'
import { getImage } from '@/src/utils/media'
import { useRouter } from 'next/router'

export interface CardData {
  title: string
  content: string
  src: string
  btnText: string
  path: string
  buttonId: string
}

const SRC_PATH = 'website/orkaCare'
const data: {
  title: string
  cardData: CardData[]
} = {
  title: 'Before Your Purchase',
  cardData: [
    {
      title: 'Wonder if You Have Hearing Loss?',
      content:
        'Take an online screening and get instant results from the comfort of your home. No waiting rooms.',
      src: 'HearingScreening.jpg',
      btnText: 'Take Free Screening',
      path: '/HearingScreening',
      buttonId: 'hearing-screening'
    },
    {
      title: `Find a local HCP`,
      content: `Our partner’s professionals are ready to answer your questions,
      whether it’s about product, service, or general hearing health.`,
      src: 'Consultation.jpg',
      btnText: 'Am I a Candidate?',
      path: '/SurveyPage',
      buttonId: 'survey'
    }
  ]
}

const PreSales = ({ sx }: { sx: SxProps }) => {
  const router = useRouter()
  return (
    <Container sx={sx}>
      <Stack spacing={5}>
        <SectionTitle>{data.title}</SectionTitle>
        <Stack spacing={5} direction={{ xs: 'column', sm: 'row' }}>
          {data.cardData.map(
            ({ title, content, btnText: ctaText, src, path, buttonId }) => (
              <ImageCard
                src={getImage(src, 'PC', SRC_PATH)}
                title={title}
                key={title}
              >
                <ContentTitle textAlign="left" mt={3}>
                  {title}
                </ContentTitle>
                <Typography mt={1} variant="body2">
                  {content}
                </Typography>
              </ImageCard>
            )
          )}
        </Stack>
      </Stack>
    </Container>
  )
}

export default PreSales
